import SoundFx from '../../../components/SoundFx';

export default function AnimationFeature() {
  const target1 = document.getElementById('AnimationCube1');
  const target2 = document.getElementById('AnimationCube2');
  const target3 = document.getElementById('AnimationCube3');

  // Unique :hover

  target1.addEventListener('mouseenter', () => {
    SoundFx.Single.play('animationUp1');
  });

  target2.addEventListener('mouseenter', () => {
    SoundFx.Single.play('animationUp2');
  });

  target3.addEventListener('mouseenter', () => {
    SoundFx.Single.play('animationUp3');
  });

  // Unique :active

  target1.addEventListener('mousedown', () => {
    SoundFx.Single.play('animationDown1');
  });

  target2.addEventListener('mousedown', () => {
    SoundFx.Single.play('animationDown2');
  });

  target3.addEventListener('mousedown', () => {
    SoundFx.Single.play('animationDown3');
  });
}
